module.exports = __webpack_public_path__ + "img/posture-perfect.d56dc05f.png";